import { useEffect, useRef, useState } from 'react';
// import './cadastroPF.css';
import { yupResolver } from '@hookform/resolvers/yup';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import '../../../assets/css/custom-toast.css';
import CheckboxGroup from '../../../components/form/CheckboxGroup';
import Input from '../../../components/form/Input';
import InputCadastro from '../../../components/form/InputCadastro';
import InputCadastroComIcone from '../../../components/form/InputCadastroComIcone';
import InputCelular from '../../../components/form/InputCelular';
import InputCpf from '../../../components/form/InputCpf';
import InputNomeCompleto from '../../../components/form/InputNomeCompleto';
import InputSenha from '../../../components/form/InputSenha';
import SelectGenero from '../../../components/form/SelectGenero';
import { abreAlertaDialog } from '../../../components/modal/AlertaDialog';
import { createFormSchemas } from './FormSchema';

const FormCadastroPF = ({ onSubmit, data }) => {
  const { t } = useTranslation();
  const { formSchemaCadastro } = createFormSchemas(t);
  const methods = useForm({ resolver: yupResolver(formSchemaCadastro) });
  const formMethods = {
    inputRef: methods.register,
    errors: methods.errors,
    control: methods.control,
    watch: methods.watch,
  };

  const [desabilitarSalvar, setDesabilitarSalvar] = useState(true);
  const [desabilitarCampoMae, setDesabilitarCampoMae] = useState(true);
  const [loading, setLoading] = useState(false);
  const isProcessing = useRef(false);
  const [radioToken, setRadioToken] = useState('E');
  const handleRadioToken = (event) => {
    setRadioToken(event.target.value);
  };
  const [isCheckedTermo, setIsCheckedTermo] = useState(false);
  const handleTermo = () => {
    setIsCheckedTermo(!isCheckedTermo);
    if (!isCheckedTermo) {
      setDesabilitarSalvar(false);
    } else {
      setDesabilitarSalvar(true);
    }
  };
  const [isCheckedNomeMaeDesconhecido, setIsCheckedNomeMaeDesconhecido] =
    useState(false);
  const [nomeMae, setNomeMae] = useState();
  const handleNomeMaeDesconhecido = () => {
    setIsCheckedNomeMaeDesconhecido(!isCheckedNomeMaeDesconhecido);
  };
  useEffect(() => {
    if (!isCheckedNomeMaeDesconhecido) {
      setDesabilitarCampoMae(false);
    } else {
      document.getElementById('nomeDaMae').value = '';
      setDesabilitarCampoMae(true);
    }
  }, [isCheckedNomeMaeDesconhecido]);
  const handleReset = () => {
    //setDesabilitarCampo(true);
    setDesabilitarCampoMae(true);
    const form = document.getElementById('formCadastro');
    const campos = form.querySelectorAll('input, select');
    campos.forEach((campo) => {
      campo.value = '';
    });
  };
  const navigate = useNavigate();
  function handleSubmit(data) {
    //  if (isProcessing.current) {
    //    console.log('Já está processando, ignorando clique...');
    //    return;
    //  }
    isProcessing.current = true; // 🔥 bloqueia novos cliques
    setLoading(true);
    try {
      if (!isCheckedTermo) {
        abreAlertaDialog(t('cadastro.messages.validation.terms_required'));
      } else {
        let nomeDaMae = data.nomeDaMae;
        if (isCheckedNomeMaeDesconhecido) {
          nomeDaMae = t('cadastro.forms.labels.unknown_mother', {
            defaultValue: 'MAE DESCONHECIDA',
          });
        }
        const telefoneFormatado = data.foneMovel.replace(/[\(\)\-\s]/g, '');
        var genero = 'N';
        if (data.genero) {
          genero = data.genero;
        }
        const dataNasc = new Date(data.dataNascimento);
        const yyyy = dataNasc.getFullYear();
        const mm = String(dataNasc.getMonth() + 1).padStart(2, '0');
        const dd = String(dataNasc.getDate()).padStart(2, '0');
        const formattedDate = `${yyyy}-${mm}-${dd}`;
        const dadosCompletoPF = {
          cpf: data.cpf.replace(/[.-]/g, ''),
          sexo: genero,
          dataNascimento: formattedDate,
          nomeDaMae: nomeDaMae.trim(),
          idCorreios: data.cpf.replace(/[.-]/g, ''),
          tipoEstrangeiro: 'N',
          foneMovel: telefoneFormatado,
          dddMovel: data.dddMovel,
          ddiMovel: '55',
          tipo: 'PF',
          termoAceito: 'S',
          nome: data.nome.trim().toUpperCase(),
          senha: data.senha,
          email: data.email.trim(),
          meioEnvio: data.meioEnvio,
          situacaoAtual: 'P',
          necessidadesEspeciais: data.necessidadesEspeciais,
        };
        onSubmit(dadosCompletoPF);
      }
    } catch (error) {
      console.error('Erro na ação:', error);
    } finally {
      setLoading(false);
    }
  }

  const listaNecessidades = [
    {
      id: 1,
      descricao: t('cadastro.forms.options.special_needs.physical', {
        defaultValue: 'Física',
      }),
    },
    {
      id: 2,
      descricao: t('cadastro.forms.options.special_needs.visual', {
        defaultValue: 'Visual',
      }),
    },
    {
      id: 3,
      descricao: t('cadastro.forms.options.special_needs.intellectual', {
        defaultValue: 'Intelectual',
      }),
    },
    {
      id: 4,
      descricao: t('cadastro.forms.options.special_needs.auditory', {
        defaultValue: 'Auditiva',
      }),
    },
    {
      id: 5,
      descricao: t('cadastro.forms.options.special_needs.psychosocial', {
        defaultValue: 'Psicossocial',
      }),
    },
    {
      id: 6,
      descricao: t('cadastro.forms.options.special_needs.multiple', {
        defaultValue: 'Múltipla',
      }),
    },
    {
      id: 7,
      descricao: t('cadastro.forms.options.special_needs.others', {
        defaultValue: 'Outras',
      }),
    },
  ];

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  }, []);
  return (
    <>
      <hr />
      <form id="formCadastro" onSubmit={methods.handleSubmit(handleSubmit)}>
        <InputCpf
          label={t('cadastro.forms.labels.cpf')}
          type="text"
          id="cpf"
          name="cpf"
          //onBlur={handleCPF}
          {...formMethods}
        />
        <InputNomeCompleto
          type="text"
          id="nome"
          name="nome"
          placeholder=""
          label={t('cadastro.forms.labels.full_name')}
          maxLength="150"
          {...formMethods}
          //disabled={desabilitarCampo}
        />
        <InputNomeCompleto
          type="text"
          id="nomeDaMae"
          name="nomeDaMae"
          label={t('cadastro.forms.labels.mothers_name')}
          placeholder=""
          {...formMethods}
          disabled={desabilitarCampoMae}
        />
        <label className="input-checkbox">
          <Input
            type="checkbox"
            id="maeDesconhecida"
            name="maeDesconhecida"
            //disabled={desabilitarCampo}
            onClick={handleNomeMaeDesconhecido}
            checked={isCheckedNomeMaeDesconhecido}
            {...formMethods}
          />
          <div className="subtitulo-p">
            {t('cadastro.forms.labels.unknown_mother_check')}
          </div>
        </label>
        <SelectGenero
          id="genero"
          // disabled={desabilitarCampo}
          label={t('cadastro.forms.labels.gender')}
          {...formMethods}
        />

        <InputCadastro
          className="input-data"
          type="date"
          id="dataNascimento"
          name="dataNascimento"
          label={t('cadastro.forms.labels.birth_date')}
          {...formMethods}
          //disabled={desabilitarCampo}
        />
        <div className="container-telefone">
          <InputCadastro
            type="text"
            className="col-1"
            campoClassName="campo-ddd"
            id="dddMovel"
            name="dddMovel"
            maxLength="2"
            placeholder="99"
            label={t('cadastro.forms.labels.ddd')}
            {...formMethods}
            // onBlur={atribuirDDI}
            //disabled={desabilitarCampo}
          />

          <InputCelular
            type="tel"
            id="foneMovel"
            name="foneMovel"
            label={t('cadastro.forms.labels.mobile')}
            {...formMethods}
            // disabled={desabilitarCampo}
          />
        </div>

        <InputCadastroComIcone
          type="email"
          id="email"
          name="email"
          label={t('cadastro.forms.labels.email')}
          placeholder="email@email.com"
          iconName="ic-carta"
          {...formMethods}
          maxLength="80"
          //disabled={desabilitarCampo}
        />

        <InputSenha
          id="senha"
          name="senha"
          label={
            t('cadastro.forms.labels.password') +
            ' ' +
            t('cadastro.messages.validation.password_requirements')
          }
          placeholder=""
          {...formMethods}
          //disabled={desabilitarCampo}
        />

        <InputSenha
          id="confirmaSenha"
          name="confirmaSenha"
          label={t('cadastro.forms.labels.confirm_password')}
          placeholder=""
          {...formMethods}
          //disabled={desabilitarCampo}
        />

        <div className="campos">
          <div className="controle">
            {listaNecessidades ? (
              <CheckboxGroup
                //className="checks"
                name="necessidadesEspeciais"
                options={[
                  ...listaNecessidades.map((item) => ({
                    id: item.id,
                    value: item.id,
                    label: item.descricao,
                  })),
                ]}
                label={t('cadastro.forms.labels.special_needs')}
                {...formMethods}
              ></CheckboxGroup>
            ) : (
              <div></div>
            )}
          </div>
        </div>

        <p className="legenda txt-obrigatorios">
          {t('cadastro.forms.labels.required_fields')}
        </p>
        <hr />

        <div className="receber-token radio-container">
          <p className="">
            {' '}
            {t('cadastro.messages.info.token_registration_method', {
              defaultValue:
                'Como deseja receber o token de confirmação de cadastro?',
            })}
          </p>

          <label className="radio">
            <Input
              type="radio"
              id="E"
              name="meioEnvio"
              value="E"
              checked={radioToken === 'E'}
              onChange={handleRadioToken}
              //disabled={desabilitarCampo}
              {...formMethods}
            />
            <div className="subtitulo-p">
              {t('cadastro.forms.options.email_option')}
            </div>
          </label>

          <label className="radio">
            <Input
              type="radio"
              id="C"
              name="meioEnvio"
              value="C"
              checked={radioToken === 'C'}
              onChange={handleRadioToken}
              //disabled="true"
              //disabled={desabilitarCampo}
              {...formMethods}
            />
            <div className="subtitulo-p">
              {t('cadastro.forms.options.mobile_option')}
            </div>
          </label>
        </div>

        <hr />
        <label className="input-checkbox">
          <Input
            type="checkbox"
            id="termo"
            name="termo"
            checked={isCheckedTermo}
            onChange={handleTermo}
            //disabled={desabilitarCampo}
          />
          <div>
            {t('cadastro.messages.info.privacy_acceptance_read', {
              defaultValue: 'Li e aceito a',
            })}
            &ensp;
            <a
              className="txt-link"
              href="https://www.correios.com.br/falecomoscorreios/politica-de-privacidade-e-notas-legais"
              target="_blank"
              rel="noopener noreferrer"
            >
              {t('cadastro.legal.privacy_policy')}
            </a>
          </div>
        </label>
        <br />

        <div className="btns-row">
          <button
            id="btn-prosseguir"
            type="submit"
            className="btn-pre primario"
            disabled={desabilitarSalvar || loading}
          >
            {loading
              ? t('cadastro.forms.buttons.processing')
              : t('cadastro.forms.buttons.register')}
          </button>

          <button
            id="btn-limpar"
            type="reset"
            className="btn-txt"
            onClick={handleReset}
            //disabled={desabilitarCampo}
          >
            {t('cadastro.forms.buttons.clear')}
          </button>
          <button
            id="btn-voltar"
            type="button"
            className="btn-txt"
            onClick={() => navigate('/login')}
          >
            {t('cadastro.forms.buttons.cancel')}
          </button>
        </div>
      </form>
    </>
  );
};
export default FormCadastroPF;
